import { DamageMainCodeResponse } from "../../api-models/response/DamageMainCodeResponse";
import { DamageC1Code } from "./DamageC1Code";
export class DamageMainCode implements DamageMainCodeResponse {
  code: string;
  text: string;
  c1Codes: DamageC1Code[];
  hasC1Codes: boolean;

  constructor(damageMainCode: DamageMainCodeResponse) {
    this.code = damageMainCode.code;
    this.text = damageMainCode.text;
    this.c1Codes = damageMainCode.c1Codes.map((x) => new DamageC1Code(x, true));
    this.hasC1Codes = damageMainCode.hasC1Codes;
  }

  get id() {
    return this.code;
  }
  get name() {
    return `${this.code} ${this.text}`;
  }
}

export const emptyMainCode = new DamageMainCode({
  code: "",
  text: "",
  c1Codes: [],
  hasC1Codes: false,
});
